import { useState } from 'react';

import useStateHandler from '@/hooks/useStateHandler';
import useTranslations from '@/i18n/useTranslations';
import GalleryService from '@/services/gallery.service';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';

import ShippingDataContent from './components/ShippingDataContent';

import './index.css';

export default function SelectShippingData({ setFormState }) {
  const t = useTranslations('common.forms.add_artwork');
  const { state, stateHandler } = useStateHandler();
  const [openShippingData, setOpenShippingData] = useState(false);

  if (!state.user_session.gallery_shippings || state.user_session.gallery_shippings.length === 0) {
    return null;
  }

  function onSelectShippingData(shippingData) {
    setFormState(prevValue => ({
      ...prevValue,
      artwork_shipping: shippingData.data
    }));
    setOpenShippingData(false);
  }

  function onUpdateShippingData(shippingData) {
    const newSavedShippingData = state.user_session.gallery_shippings.map(item => 
      item._id === shippingData._id ? shippingData : item
    );
    stateHandler.set("user_session.gallery_shippings", newSavedShippingData);
    GalleryService.updateGalleryShippings(newSavedShippingData);
  }

  function onRemoveShippingData(shippingData) {
    const newSavedShippingData = state.user_session.gallery_shippings.filter(item => item._id !== shippingData._id);
    stateHandler.set("user_session.gallery_shippings", newSavedShippingData);
    GalleryService.updateGalleryShippings(newSavedShippingData);

    if (newSavedShippingData.length === 0) setOpenShippingData(false);
  }

  return (
    <>
      <Text
        className="select-shipping-data-opener element-non-selectable"
        onClick={() => setOpenShippingData(true)}>
        {t('shipping.saved_rates_opener')}
      </Text>
      {/* ✅ Popup is now properly controlled */}
      <GenericPopup 
        open={openShippingData} 
        onBackgroundClick={() => setOpenShippingData(false)}
        className="shipping-data-content__popup remove-scrollbar"
        opacity 
      >
        <ShippingDataContent
          shippingData={state.user_session.gallery_shippings}
          onSelectShippingData={onSelectShippingData}
          onUpdateShippingData={onUpdateShippingData}
          onRemoveShippingData={onRemoveShippingData}
          close={() => setOpenShippingData(false)}
        />
      </GenericPopup>
    </>
  );
}
